__turbopack_context__.v({
  "arrowIcon": "AiInRecruitingIndustrySection-module__xd2y2W__arrowIcon",
  "itemDesc": "AiInRecruitingIndustrySection-module__xd2y2W__itemDesc",
  "itemIcon": "AiInRecruitingIndustrySection-module__xd2y2W__itemIcon",
  "itemTitle": "AiInRecruitingIndustrySection-module__xd2y2W__itemTitle",
  "listItem": "AiInRecruitingIndustrySection-module__xd2y2W__listItem",
  "listWrapper": "AiInRecruitingIndustrySection-module__xd2y2W__listWrapper",
  "whySection": "AiInRecruitingIndustrySection-module__xd2y2W__whySection",
  "whySubtitle": "AiInRecruitingIndustrySection-module__xd2y2W__whySubtitle",
  "whyTitle": "AiInRecruitingIndustrySection-module__xd2y2W__whyTitle",
});
